import { render } from "./ChangeGroupModal.vue?vue&type=template&id=43a9892e&ts=true"
import script from "./ChangeGroupModal.vue?vue&type=script&lang=ts"
export * from "./ChangeGroupModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__